import React from 'react';
import { Table, Icon, ClippedContent, Person, DateTimeUtils } from 'dyl-components';
import { PhoneUtil } from 'utils';

const TextHistoryRow = ({ message, onRowClick, selectedRow }) => {
    const phone = PhoneUtil.formatPhoneNumber(message.contact_phone);
    const isLogActivityLog = !message.customer_phone
    return (
        <Table.Row className='TextHistory__row' onClick={()=>{onRowClick(message)}} active={selectedRow === message.id}>
            <Table.Cell className="Text__actions Text__actions--read ">
               {!isLogActivityLog && <Icon
                    className={message.read ? "fa-solid fa-circle-dashed" : "fa-solid fa-circle"}
                />}
            </Table.Cell>
            <Table.Cell className="TextTabTable__SmallFixedWidth" >
                <div className='Text__actions' style={{ display: 'flex', alignItems: 'center', gap:10 }}>
                    <div>
                        <b>{DateTimeUtils.formatEpoch(message.message_ts, "MM/DD/YYYY")}</b>
                        <div>{DateTimeUtils.formatEpoch(message.message_ts, DateTimeUtils.TIME_FORMAT)}</div>
                    </div>
                    <Icon className={`fa-solid fa-${message.customer_phone ? 'comments' : 'clock-rotate-left'}`} primary />
                </div>
            </Table.Cell>
            <Table.Cell >
                <div className="TextTabTable__SmallFixedMaxWidth TextTabTable_PersonName">
                    {message.contact_name ? (
                            <Person link={message?.link} username={message?.contact_name} email={phone} isUsernameOnly={isLogActivityLog} subtitleLabel="Phone" />
                    ) : (
                        phone
                    )}
                </div>
            </Table.Cell>
            <Table.Cell>
                {!isLogActivityLog && PhoneUtil.formatPhoneNumber(message.customer_phone)}
            </Table.Cell>
            <Table.Cell >
            <div className='TextTabTable__LargeFixedWidth'>
                <ClippedContent>{message.last_message?.message}</ClippedContent>
            </div>
            </Table.Cell>
        </Table.Row>
    );
};

export default TextHistoryRow;
